import "./App.css";
import "antd/dist/reset.css";

import { publicRoute } from "./Route/PublicRoute";
// import { checkTokenApi } from "./page/Login/api";
import { privateRoute } from "./Route/PrivateRoute";
import HandleAccessRoute from "./Route/HandleAccessRoute";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const App = (props) => {
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const getToken = sessionStorage.getItem("token_login");

  //     if (!getToken) return;

  //     checkTokenApi()
  //       .then((res) => {})
  //       .catch((err) => {});
  //   }, 10000); // cek token tiap 10 second

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <BrowserRouter>
      <Routes>
        {publicRoute.map((item, index) => {
          return <Route key={index} path={item.path} element={item.element} />;
        })}

        <Route element={<HandleAccessRoute />}>
          {privateRoute.map((item, index) => {
            return (
              <Route key={index} path={item.path} element={item.element} />
            );
          })}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
